<template>
  <v-footer color="grey" absolute app inset></v-footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
